import { ThemeProvider } from "@material-ui/core";
import getTheme from "../shared/getTheme";
import { AppType } from "../theme/types";

export default function LyfeTheme(props: { app: AppType; children?: JSX.Element | Array<JSX.Element> }) {
	return <ThemeProvider theme={getTheme(props.app)}>{props.children}</ThemeProvider>;
}
